import { formatMoney } from 'infra/helpers/number';
export function formatAreaComumValor(valor: number | null, valorMinimo: number | null, valorMaximo: number | null) {
  if (valor !== null) {
    return formatMoney(valor)
  } else if (valorMinimo !== null && valorMaximo !== null && valorMinimo !== valorMaximo) {
    return formatMoney(valorMinimo) + ' até ' + formatMoney(valorMaximo)
  } else if (valorMinimo !== null && valorMaximo !== null && valorMinimo === valorMaximo) {
    return formatMoney(valorMinimo)
  }
  return '--'
}